import { render, staticRenderFns } from "./CertificateRequestTemplateEdit.vue?vue&type=template&id=24ef2d6c&scoped=true"
import script from "./CertificateRequestTemplateEdit.vue?vue&type=script&lang=js"
export * from "./CertificateRequestTemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./CertificateRequestTemplateEdit.vue?vue&type=style&index=0&id=24ef2d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef2d6c",
  null
  
)

export default component.exports